import React, { Component, createRef, ReactNode, RefObject } from 'react';
import { Request, UploadType } from '../Utils';
// @ts-ignore
import default_audio from '../../assets/images/tw/default_audio.jpeg';
import './index.scss';
// @ts-ignore
import GrtPlayer from 'grt-player';
const { initPlayer: XGPlayer } = GrtPlayer;
type CreateUserType = {
    real_name?: string;
    user_name?: string;
    id?: string;
    mobile?: string;
};

export interface Detail {
    type?: UploadType;
    name?: string;
    ext_type?: string;
    size?: number;
    org_id_list?: any[];
    category_name?: string;
    ref_count?: number;
    create_time?: number;
    duration?: number;
    default_url?: string;
    create_user?: CreateUserType;
    asset_id?: string;
    ai_state?: 0 | 1;
    ie_state?: 0 | 1;
}

interface Props {
    detail: Detail;
    needToken?: boolean;
    tokenUrl?: string;
    /** 自定义class*/
    className?: string;
    // eslint-disable-next-line no-unused-vars
    initPlayer?: (player: any) => void;
    playerOptions?: any;
}

interface State {
    detail: Detail;
}

class ViewSource extends Component<Props, State> {
    state: State = {
        detail: this.props.detail
    };
    player: any = null;

    static getDerivedStateFromProps(nextProps: Props, prevState: State) {
        if (nextProps.detail && nextProps.detail !== prevState.detail) {
            prevState.detail = nextProps.detail;
            return prevState;
        }
        return null;
    }

    componentWillUnmount() {
        this.player?.destroy();
    }

    componentDidMount() {
        if (this.state.detail) {
            this.content();
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>) {
        if (prevState.detail && prevProps.detail && prevState.detail?.default_url !== prevProps.detail?.default_url) {
            this.content();
        }
    }

    content(): null {
        if (this.player) {
            this?.player?.destroy();
        }
        const options: any = Object.assign(
            {},
            {
                volume: 1,
                el: this.videoRef?.current,
                url: '',
                fluid: true,
                // fitVideoSize: 'auto',
                autoplay: true,
                ignores: ['fullscreen'],
                cssFullscreen: true,
                playbackRate: [0.75, 1, 1.25, 1.5, 2]
            },
            this.props.playerOptions || {}
        );
        // @ts-ignore
        if (this.props.detail?.type === 3) {
            options.videoBackground = {
                isCustom: true,
                background: default_audio
            };
            options.fitVideoSize = 'fixHeight';
            options.width = '100%';
            options.height = '368px';
        }
        if (typeof this.props.needToken !== 'undefined' && !this.props.needToken) {
            options.url = this.state.detail.default_url;
            this.player = XGPlayer(options);
            if (this.props?.initPlayer) this.props?.initPlayer(this.player);
        } else {
            this.getToken().then((res: any) => {
                console.log('获取token', res);
                // options.url = this.state.detail.default_url + "?token=" + res;
                options.url = `${this.state.detail.default_url}?MtsHlsUriToken=${res}&token=${res}`;
                this.player = XGPlayer(options);
                if (this.props?.initPlayer) this.props?.initPlayer(this.player);
            });
        }
        return null;
    }

    getToken() {
        let assetId = this.state.detail.asset_id;
        if (!assetId) {
            const url = this.state.detail.default_url;
            assetId = url?.substring(url?.indexOf('asset/') + 6, url?.indexOf('/play_video'));
        }
        if (!assetId) return Promise.reject(false);
        return Request.get(this.props.tokenUrl + assetId, {
            assetId,
            asset_id: assetId
        });
    }

    videoRef: RefObject<any> = createRef();

    render(): ReactNode {
        return (
            <>
                {this.state.detail.type === UploadType.AUDIO || (this.state.detail.type === UploadType.VIDEO && this.state.detail.asset_id) ? (
                    <div
                        className={this.props?.className}
                        style={{
                            background: 'rgba(0,0,0,0.85)',
                            height: '100%',
                            width: '100%',
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <div id={'player'} className={'grt-player'} style={{ margin: '0 auto', height: '100%' }} ref={this.videoRef}></div>
                    </div>
                ) : (
                    <img
                        style={{
                            display: 'block',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            margin: '0 auto'
                        }}
                        src={this.state.detail.default_url}
                        alt={this.state.detail.name}
                    />
                )}
            </>
        );
    }
}

export default ViewSource;
